import React from "react";
import { Link } from "react-router-dom";
import { Separator } from "./Separator";

export type LegalNotesProps = {};

export class LegalNotes extends React.Component<LegalNotesProps> {
  render() {
    return (
      <div>
        <Link to="/">Retour au calculateur</Link>
        <h2>Investissement</h2>
        <Separator />
        <p>
          Ce site est édité et hébergé par Stéphane Magne sur infrastructure{" "}
          <a href="https://www.ovhcloud.com/fr/" title="OVH Cloud">
            OVHcloud – 2 rue Kellermann, 59100 Roubaix, France
          </a>{" "}
          Il est géographiquement localisé dans le centre d'hébergement français{" "}
          <b>de Gravelines</b> depuis Avril 2026.
        </p>
        <h2>Données personnelles</h2>
        <Separator />
        <p>
          Votre adresse IP et la référence de la page visitée font partie des
          informations personnelles enregistrées sur le serveur qui héberge ce
          site.
        </p>
        <p>Aucune autre donnée personnelle n'est enregistrée</p>
      </div>
    );
  }
}
